import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AddToCalendar({ ticketId, variant = "default", size = "default" }) {
  const [calendarLinks, setCalendarLinks] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCalendarLinks();
  }, [ticketId]);

  const fetchCalendarLinks = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/tickets/${ticketId}/calendar-links`);
      setCalendarLinks(response.data);
    } catch (error) {
      console.error('Error fetching calendar links:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToCalendar = (type) => {
    if (!calendarLinks) {
      toast.error('Caricamento link calendario...');
      return;
    }

    switch(type) {
      case 'google':
        window.open(calendarLinks.google, '_blank');
        toast.success('Apertura Google Calendar...');
        break;
      case 'outlook':
        window.open(calendarLinks.outlook, '_blank');
        toast.success('Apertura Outlook...');
        break;
      case 'office365':
        window.open(calendarLinks.office365, '_blank');
        toast.success('Apertura Office 365...');
        break;
      case 'apple':
      case 'download':
        // Download .ics file
        window.location.href = `${API_URL}/tickets/${ticketId}/calendar.ics`;
        toast.success('Download file calendario...');
        break;
      default:
        break;
    }
  };

  if (loading || !calendarLinks) {
    return (
      <Button variant={variant} size={size} disabled>
        <Calendar className="w-4 h-4 mr-2" />
        Caricamento...
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className="gap-2">
          <Calendar className="w-4 h-4" />
          Aggiungi al Calendario
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuItem 
          onClick={() => handleAddToCalendar('google')} 
          className="gap-3 cursor-pointer"
        >
          <span className="text-2xl">📅</span>
          <div>
            <p className="font-medium">Google Calendar</p>
            <p className="text-xs text-gray-500">Apri in Google Calendar</p>
          </div>
        </DropdownMenuItem>
        
        <DropdownMenuItem 
          onClick={() => handleAddToCalendar('outlook')} 
          className="gap-3 cursor-pointer"
        >
          <span className="text-2xl">📧</span>
          <div>
            <p className="font-medium">Outlook.com</p>
            <p className="text-xs text-gray-500">Apri in Outlook Web</p>
          </div>
        </DropdownMenuItem>

        <DropdownMenuItem 
          onClick={() => handleAddToCalendar('office365')} 
          className="gap-3 cursor-pointer"
        >
          <span className="text-2xl">💼</span>
          <div>
            <p className="font-medium">Office 365</p>
            <p className="text-xs text-gray-500">Apri in Office 365</p>
          </div>
        </DropdownMenuItem>
        
        <DropdownMenuItem 
          onClick={() => handleAddToCalendar('apple')} 
          className="gap-3 cursor-pointer"
        >
          <span className="text-2xl">🍎</span>
          <div>
            <p className="font-medium">Apple Calendar</p>
            <p className="text-xs text-gray-500">Download file .ics</p>
          </div>
        </DropdownMenuItem>

        <DropdownMenuItem 
          onClick={() => handleAddToCalendar('download')} 
          className="gap-3 cursor-pointer"
        >
          <span className="text-2xl">📥</span>
          <div>
            <p className="font-medium">Download .ics</p>
            <p className="text-xs text-gray-500">File per altri calendari</p>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
